// extracted by mini-css-extract-plugin
module.exports = {"boxAdd":"_260pbJtO68l9rc8ePbDCzI","boxDiv":"_2TDcrRhvAe6vjtq6_ZFNSs","box":"_3MSIGkGyB3hKvtqMH5zkQA"};